import { cloneDeep } from 'lodash'
import { ShipUpgrade } from '@prometheus/types'
import { formatZeros } from './formatZeros'

export function createShipUpgradeLevels(_shipUpgrade: ShipUpgrade[]) {
  if (!_shipUpgrade.length) return _shipUpgrade
  let SMU = cloneDeep(_shipUpgrade)

  for (let i = 10; i < 15; i++) {
    SMU.push({
      max: SMU[i - 1].max * 2,
      cost: { income: (SMU[i - 1].cost.income || 0) * 8.5, resources: {
        Fe: Math.round((SMU[i - 1].cost.resources?.Fe || 0) * 3),
        Pt: Math.round((SMU[i - 1].cost.resources?.Pt || 0) * 3),
        U: Math.round((SMU[i - 1].cost.resources?.Pt || 0) * 3) } },
    })
  }

  for (let i = 15; i < 102; i++) {
    SMU.push({
      max: SMU[i - 1].max * 2,
      cost: { income: (SMU[i - 1].cost.income || 0) * 4.6, resources: {
        Fe: Math.round((SMU[i - 1].cost.resources?.Fe || 0) * 2.5),
        Pt: Math.round((SMU[i - 1].cost.resources?.Pt || 0) * 2.5),
        U: Math.round((SMU[i - 1].cost.resources?.Pt || 0) * 2.5) } },
    })
  }

  for (let i = 8; i < 102; i++) {
    SMU[i].max = formatZeros(SMU[i].max, 1)
    SMU[i].cost.income = formatZeros((SMU[i].cost.income || 0), 1)
    const resources = SMU[i].cost.resources
    if (resources) {
      resources.Fe = formatZeros(Math.round((SMU[i].cost.resources?.Fe || 0)), 2)
      resources.Pt = formatZeros(Math.round((SMU[i].cost.resources?.Pt || 0)), 2)
      resources.U = formatZeros(Math.round((SMU[i].cost.resources?.U || 0)), 2)
    }
  }

  return SMU
}
